import { CreateDIV } from '../HTML';
import { getLanguageString } from '../common';

// MAIN SCRIPTING
export const hasBanner = false;
window.hasBanner = hasBanner;

export const Components = window.Components ?? {};

// GENERAL EVENT HANDLER(S)
const resizeEvents = [];
export function Component() {
  this.registerResize = function (f) {
    resizeEvents.push(f);
  };
}
Components.Component = Component;

// WIJZIGEN
export function get_cat(id) {
  var o = window.websession.NewsCategoryList;

  for (var x = 0; x < o.length; x++) {
    if (o[x].Id === id) {
      return getLanguageString(o[x].Name);
    }
  }
  return '';
}
window.get_cat = get_cat;
// WIJZIGEN

export function SpacerTop(Owner) {
  this.divSpacer = CreateDIV(Owner, 'spacer-top');
}
Components.SpacerTop = SpacerTop;

SpacerTop.prototype = {
  hide: function () {
    this.divSpacer.style.display = 'none';
  },
};

export function SpacerTopFilter(Owner) {
  CreateDIV(Owner, 'plus-filter');
}
Components.SpacerTopFilter = SpacerTopFilter;

export function SpacerDynamic(Owner, Height) {
  var _self = this;

  this.owner = Owner;
  this.height = Height;

  this.divSpacer = CreateDIV(
    Owner,
    null,
    'height: ' + _self.calcHeight(Height) + 'px;'
  );
}
Components.SpacerDynamic = SpacerDynamic;

SpacerDynamic.prototype = {
  calcHeight: function (value) {
    var height = value;

    if (window.innerWidth < 321) {
      height = this.height / 3;
    } else if (window.innerWidth < 769) {
      height = this.height / 1.5;
    }

    return height;
  },
  setHeight: function () {
    this.divSpacer.style.height = this.calcHeight(this.height) + 'px';
  },
};

// IE IMAGE CORRECTION BANNER
export function IEImageCorrection() {
  setTimeout(function () {
    // IE11 / EDGE WORKAROUND
    if ('objectFit' in document.documentElement.style === false) {
      // assign HTMLCollection with parents of images with objectFit to variable
      var container = document.getElementsByClassName('js-banner');

      // Loop through HTMLCollection
      for (var i = 0; i < container.length; i++) {
        if (container[i].querySelector('img') !== null) {
          // Asign image source to variable
          var imageSource = container[i].querySelector('img').src;

          // Hide image
          container[i].querySelector('img').style.display = 'none';

          // Add background-size: cover
          container[i].style.backgroundSize = 'cover';

          // Add background-image: and put image source here
          container[i].style.backgroundImage = 'url(' + imageSource + ')';

          // Add background-position: center center
          container[i].style.backgroundPosition = 'center center';
        }
      }
    }
  }, 50);
}
Components.IEImageCorrection = IEImageCorrection;

// RESIZE EVENT LISTENER
window.addEventListener(
  'resize',
  function (event) {
    if (!/mux-player/i.test(event.target.tagName)) {
      resizeEvents.forEach(function (re) {
        re.resize();
      });
    }
  },
  true
);

export function mobileAndTabletcheck() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
Components.mobileAndTabletcheck = mobileAndTabletcheck;

export function mobilecheck() {
  var check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}
Components.mobilecheck = mobilecheck;

// *******************************************
// TOEVOEGING NA MARKETING SPLIT OFF
export function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}
Components.addDays = addDays;

export function addMonths(date, months) {
  var result = new Date(date);
  result.setMonth(result.getMonth() + months);
  return result;
}
Components.addMonths = addMonths;

export function addYears(date, years) {
  var result = new Date(date);
  result.setYear(result.getFullYear() + years);
  return result;
}
Components.addYears = addYears;

export function monthNumberToString(m) {
  var months = lang.generic.monthnames.split(',');
  return months[m];
}
Components.monthNumberToString = monthNumberToString;

// CALCULATE REPORT PERIOD
/**
 * @description Calculate report period
 * @param {string} x - Period type
 * @returns {Array.<date,date>} - Array with start- and end date
 * @method getPeriod
 * @memberof Components.Filter#
 */
export function getPeriod(x) {
  var startPeriod, endPeriod;

  switch (x) {
    case '9':
      var start = new Date();
      start.setDate(1);
      start.setMonth(start.getMonth() - 1);
      startPeriod = start;
      var last_date = new Date(start.getFullYear(), start.getMonth() + 1, 0);
      endPeriod = last_date;
      break;
    case '8':
      startPeriod = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ); //new Date();
      endPeriod = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ); //Components.addDays(startPeriod, 1);
      break;
    case '7':
      endPeriod = Components.addDays(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
        -1
      ); //new Date();
      startPeriod = Components.addDays(endPeriod, -6);
      break;
    case '6':
      endPeriod = new Date();
      startPeriod = new Date(endPeriod.getFullYear(), endPeriod.getMonth(), 1);
      break;
    case '5':
      endPeriod = Components.addDays(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
        -1
      ); //new Date();
      startPeriod = Components.addDays(endPeriod, -29);
      break;
    case '4':
      endPeriod = Components.addDays(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
        -1
      ); //new Date();
      startPeriod = Components.addDays(endPeriod, -89);
      break;
    case '3':
      endPeriod = new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ); //new Date();
      startPeriod = new Date(endPeriod.getFullYear(), 0, 1);

      break;
    case '2':
      endPeriod = Components.addDays(
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate()
        ),
        -1
      ); // new Date();
      startPeriod = Components.addDays(endPeriod, -364);
      break;
    case '1':
      var d = new Date();
      startPeriod = new Date(d.getFullYear() - 1, 0, 1);
      endPeriod = new Date(d.getFullYear() - 1, 11, 31);
      break;
    case '0':
      startPeriod = null;
      endPeriod = null;
      break;
  }

  return [
    moment(startPeriod).format('YYYY-MM-DD'),
    moment(endPeriod).format('YYYY-MM-DD'),
  ];
}
Components.getPeriod = getPeriod;

/** Compatitibility */
window.Components = Components;
